<div class="w-100 text-center">
    <h1>You do not have the permissions to do this task.</h1>
</div>